import axios from '@/axios';

const RESOURCE_NAME = '/startup/profile';

export default {

    getInfo() {
        return axios.get(`${RESOURCE_NAME}/get-info`)
    },

    saveInfo(data) {
        return axios.post(`${RESOURCE_NAME}/save-info`, data)
    },

    profileCompleted() {
        return axios.get(`${RESOURCE_NAME}/profile-completed`)
    },

    getEmailTemplateEdit(type) {
        return axios.get(`${RESOURCE_NAME}/get-email-template-edit?type=${type}`)
    },

    saveEmailTemplate(type, data) {
        return axios.post(`${RESOURCE_NAME}/save-email-template?type=${type}`, data)
    },
}
